import { AxiosResponse } from "axios";
import ApiConstants from "../../../../constants/api_constants";
import { request } from "../../../../network/axiosInstance";

export class ActualityApiService {
    private readonly actualityBaseUrl: string;

    constructor() {
        this.actualityBaseUrl = ApiConstants().actuality.substring(0, ApiConstants().actuality.length - 1);
    }

    async getNews(skip: number, limit: number): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: this.actualityBaseUrl,
            requiresToken: true,
            params: {
                skip,
                limit
            }
        });
        return response;
    }
} 